import { DetailsBooking } from 'types';

const getGuestSummary = (booking: DetailsBooking) => {
  const { adults, children, infants } = booking.reservation;
  const { given, family } = booking.reservation.leadGuest.name;

  let occupantsText = '';
  const addOccupantGroup = (count: number, singular: string, plural: string) => {
    occupantsText += count === 0 ? '' : count === 1 ? `${count} ${singular}, ` : `${count} ${plural}, `;
  };

  addOccupantGroup(adults, 'adult', 'adults');
  addOccupantGroup(children, 'child', 'children');
  addOccupantGroup(infants, 'infant', 'infants');

  return `${occupantsText}reserved for ${given} ${family}`;
};

export default getGuestSummary;
